<script>
	let logo = 'tpc_logo_white.png'
</script>

<main>
  <h1>
        <img src={logo} alt = "Titan Point Capital Management, LP">
  </h1>

	<h2>
		<h3>Titan Point Capital is a U.S-based <a href="https://en.wikipedia.org/wiki/Market_neutral">market neutral</a>, <a href="https://en.wikipedia.org/wiki/Statistical_arbitrage">statistical arbitrage</a> hedge fund that operates with a strict adherence to scientific and mathematical principles.
                </h3>
	</h2>

<h5>
<a href="mailto:patrick@tpclp.com">Contact Us</a> &nbsp; <a href="https://patrickhop.medium.com">Blog</a>
</h5>

	<h4>
    COPYRIGHT © 2023 TITAN POINT CAPITAL MANAGEMENT, LP
	</h4>
</main>


<style>
	main {
		text-align: center;
		padding: 0em;
		margin: 0 auto;
	}

	h1 {
	        margin-left: auto;
                margin-right: auto;
		margin-bottom: .5%;
		margin-top: 14%;
		height: 52%;
		width: 52%;
		max-height: 410px;
		max-width: 410px;
	}

        h2 {
		/* background: #f7f7f7; */
		padding: 1%;
	}
	
	h3 {
		font-size: .72em;
		font-weight: 440;
                position: center;
		padding: 0%;
		margin-left: 13%;
		margin-right: 13%;
	}
	
	h4 {
		font-size: .65em;
		font-weight: 500;
		padding: 0%;
	}

        h5 {
                font-size: .9em;
		font-weight: 440;
		margin-top: 1.5%;
        }

	img {
		position: center;
		max-width: 50%;
		height: auto;
                padding: 1.5%;
            }


	@media (min-width: 480px) {
		main {
			max-width: none;
		}
	}
</style>
